import { writable } from 'svelte/store';

export const collection = writable([]);

export const collectionItemId = writable(undefined)
